import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { RootState } from "@assessment/store/store";
import { resolveSupportedLanguage } from "./languages";
import {
  getStoredAuthoringLanguage,
  setStoredAuthoringLanguage
} from "@lxp-app/utils/authoringLibraryResources/authoringLibraryLanguages";

export const usePreferredLanguageSync = () => {
  const { i18n } = useTranslation();
  const preferredLanguage = useSelector(
    (state: RootState) => state.UserInfoSlice.profile?.preferences?.language
  );

  useEffect(() => {
    const resolvedPreference = resolveSupportedLanguage(preferredLanguage);
    if (!resolvedPreference) return;

    const currentLanguage = resolveSupportedLanguage(
      i18n.resolvedLanguage || i18n.language
    );

    if (currentLanguage !== resolvedPreference) {
      void i18n.changeLanguage(resolvedPreference);
    }

    const currentAuthoringLanguage = getStoredAuthoringLanguage();
    if (currentAuthoringLanguage !== resolvedPreference) {
      setStoredAuthoringLanguage(resolvedPreference);
    }
  }, [preferredLanguage, i18n]);
};
